// extracted by mini-css-extract-plugin
export default {"wrap":"vG-z","fullWidth":"wG-z","hideOnDesktop":"xG-z","content":"yG-z","hasOpenedNav":"zG-z","crumbsList":"AG-z","dropdownsWrap":"BG-z"};